import Axios from '../data-access/genericAxios';
import {ifacSecurityURL} from "../../utility/apiURLS";
import { getcompanyId,getuserId } from '../../utility/tokenUtility';
async function validateUser(loginObj) {
  // loginObj = { email:'string', password:'string' }
  const response = await Axios.authPost(`${ifacSecurityURL}/api/authenticate`, loginObj);
  
  return response;
}
async function changePassword(values) { 
  const response = await Axios.post(`${ifacSecurityURL}/api/account/change-password`,values); 
   return response;
 }

 async function hospitalNameList() {
  const companyId = getcompanyId("companyId");
  const userID = getuserId("userID");
  // model attribute for requestbody
  const response = await Axios.get(
    `${ifacSecurityURL}/api/GraphUserdetails/GetAllFacilityDetailsByCompanyIdAndUserId/${companyId}/${userID}`
  );
 
  return response;
}
const UserRepository = {
   validateUser,
   changePassword,
   hospitalNameList
};

export default UserRepository;
